







import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import { Data as HeadlinesData, DataWithHref } from '@root/modules/headlines/types/headlines';
import UniversalHeadlinesService from '@root/modules/headlines/services/UniversalHeadlines.service';
import getHeadlineWithHref from '@root/modules/headlines/utils/getHeadlineWithHref';
import HeadlineBlocks from '@root/common/components/base/headline/HeadlineBlocks.vue';

interface Props {
  article: ArticleData;
}

interface Methods {
  getHeadline: (headline: HeadlinesData) => DataWithHref;
  getSimilarHeadlines: () => void;
  getHeadlines: () => Promise<HeadlinesData[]>;
}

interface Data {
  data: Record<string, any>;
  domain: string;
  headlines: HeadlinesData[];
  limit: number;
  settings: Record<string, any>;
}

export default Vue.extend<Data, Methods, unknown, Props>({
  components: {
    HeadlineBlocks,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  data() {
    const { domain } = this.$channelConfig('settings');
    return {
      data: {
        items: [],
      },
      domain,
      headlines: [],
      limit: 5,
      settings: {
        category: false,
        channel: false,
        lead: false,
        publishDate: false,
        author: false,
        titleComment: true,
        views: true,
        videoDuration: false,
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getSimilarHeadlines();
    });
  },
  methods: {
    getHeadline(headline) {
      const fakeDomainEnabled = this.$config.FAKE_DOMAIN_ENABLED;
      return getHeadlineWithHref({ headline, domain: this.domain, fakeDomainEnabled });
    },
    async getSimilarHeadlines() {
      const headlines = await this.getHeadlines();
      if (headlines.length) {
        this.headlines = headlines.map(headline => this.getHeadline(headline)) || [];
      }
    },
    async getHeadlines() {
      let tagIds: number[] = [];
      let categoryIds: number[] = [];

      this.$props.article.tags.items.forEach((tag: any) => {
        tagIds.push(tag.id);
      });

      if (!tagIds.length) {
        categoryIds.push(this.$props.article.primaryCategory.id);
      }

      const excludeIds = [this.$props.article.id];

      const universalHeadlinesService = new UniversalHeadlinesService();
      const headlines = await universalHeadlinesService.fetch({
        domain: this.domain,
        categoryId: categoryIds,
        tagId: tagIds,
        excludeIds,
        limit: this.limit,
        getViews: true,
      });
      return headlines.items;
    },
  },
});
